



































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useDarkModeController from "@/hooks/useDarkModeController";
import { darkModeReplacePostfix } from "@/lib/darkModeReplacePostfix";
import { getQuestionaryInfoFields } from "@/lib/questionaryFieldsHelper";
import config from "@/config";
import BaseIcon from "@/components/BaseIcon";

interface Social {
  id: string;
  href: string;
  iconName: string;
}
interface Info {
  id: string;
  text: string;
  class: string;
  tag: string;
  icon?: string;
  attrs: Record<string, string>;
}

@Component({
  name: "QuestionaryInfoPrinter",
  components: { BaseIcon },
  setup() {
    const { isDarkMode } = useDarkModeController();

    return { isDarkMode };
  },
})
export default class QuestionaryInfoPrinter extends Vue {
  @Prop({ required: true })
  public readonly questionaryInfo!: Record<string, string>;

  @Prop({ required: true })
  public readonly user!: UserPublicData;

  public isDarkMode!: ReturnType<typeof useDarkModeController>["isDarkMode"]["value"];

  public get restrictedMember() {
    return config.featureRestrictMember && this.user.role === "member";
  }

  public get availableInfos(): Info[] {
    return getQuestionaryInfoFields()
      .filter(
        i =>
          !i.fieldMeta?.social &&
          !i.fieldMeta?.amazon &&
          (this.restrictedMember ? i.fieldMeta?.allowedForMember : true) &&
          this.questionaryInfo[i.name]
      )
      .map(infoField => {
        const classes = [
          ...(infoField.fieldMeta?.description ? ["caption"] : []),
          ...(infoField.fieldMeta?.caption ? ["questionary-info__location mt-2"] : []),
          ...(infoField.fieldMeta?.url ? ["questionary-info__link link mt-2"] : []),
        ];
        let text = this.questionaryInfo[infoField.name];
        if (infoField.fieldMeta?.url) {
          text = text.replace(/(^\w+:|^)\/\//, "");
        }
        return {
          id: infoField.name,
          text,
          class: classes.join(" "),
          tag: infoField.fieldMeta?.url ? "a" : "div",
          attrs: {
            ...(infoField.fieldMeta?.url ? { href: this.questionaryInfo[infoField.name], target: "_blank" } : {}),
          },
          ...(infoField.fieldMeta?.icon ? { icon: infoField.fieldMeta?.icon } : {}),
        };
      });
  }

  public get availableSocials() {
    if (this.restrictedMember) return [];
    return getQuestionaryInfoFields()
      .filter(i => i.fieldMeta?.social)
      .reduce((out, socialField) => {
        if (this.questionaryInfo[socialField.name])
          out.push({
            id: socialField.name,
            href: `${socialField.fieldMeta?.site ?? ""}${this.questionaryInfo[socialField.name]}`,
            iconName: darkModeReplacePostfix(socialField.appendIcon ?? "", this.isDarkMode),
          });
        return out;
      }, [] as Social[]);
  }

  public get availableAmazonLinks() {
    return getQuestionaryInfoFields()
      .filter(i => i.fieldMeta?.amazon)
      .reduce((out, amazonField) => {
        if (this.questionaryInfo[amazonField.name])
          out.push({
            id: amazonField.name,
            href: this.questionaryInfo[amazonField.name],
            iconName: darkModeReplacePostfix(amazonField.fieldMeta?.logo ?? "", this.isDarkMode),
          });
        return out;
      }, [] as Social[]);
  }
}
